import React, { Component } from 'react';
import PropTypes from 'prop-types';
import headerActions from '../../reusable/Header/Header.actions';
import {hashHistory, withRouter} from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import xhr from './../../utils/xhr';
import entityDashboardActions from '././../../api/Common.api';
import api from '../../api/EditThirdParty.api';
import AboutThisEntity from './components/AboutThisEntity/AboutThisEntity';
import NewsVolumeChart from './../../reusable/NewsVolumeChartPod/NewsVolumeChart.jsx';
import TrendingTerms from './../../pages/StartPage/Dashboard/components/TrendingIndexTermPod/TrendingTermsPod';
import { ENTITIES_FILTER_SPECIFIC, PERSISTED_FILTERS_MAP, ENTITIES_FILTER_CATEGORIES } from './../../constants';
import { EntityDashboardSanctionsPod } from '../../containers/SanctionsWarnings/SanctionsWarnings.containers';
import EntityDashboardFilters from './components/EntityDashboardFilters';
import { forEach } from 'lodash';
import { connect } from 'react-redux';
import utils from "../../utils/utilities";
import {LS_KEY_PERSISTED_ENTITY_FILTERS, LS_KEY_PERSISTED_ENTITY_PREFS} from "../../constants";
import storage from '../../utils/storage';

class EntityDashboard extends Component {
    static propTypes = {
        updateFilters: PropTypes.func,
        updatePrefs: PropTypes.func,
        filters: PropTypes.object,
        prefs: PropTypes.object
    }

    constructor(props) {
        super(props);

        // Entity Dashboard state
        this.state = {
            companyId:   this.props.params.companyId,
            companyData: null,
            experianData: null,
            categories:  [],
            prefs: props.prefs,
            filters: props.filters
        };

        this.goBack = this.goBack.bind(this);
        this.loadExperianData = this.loadExperianData.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.handlePodsVisibility = this.handlePodsVisibility.bind(this);
        this.buildSanctionsPod = this.buildSanctionsPod.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader('emptySubMenuVisible');

        entityDashboardActions.loadCompanyData(this.props.params.companyId)
            .then((companyData) => {
                headerActions.updateHeader({
                    menuStateClass: '',
                    subMenuMessage: companyData.companyTitle,
                    helpUrl:        'aboutentitytips-field?lbu=US&locale=en_US&audience=all'
                });
                this.setState({companyData: companyData, categories: companyData.categoryIds});
                this.loadExperianData(companyData.experianBusinessId)
            })
            .catch((error) => {
                xhr.handleAllErrors(error);
        });
    }

    getFilters() {
        return {
            ...this.state.filters,
            entities: {
                type: ENTITIES_FILTER_SPECIFIC,
                entitiesId: [this.props.params.companyId]
            }
        }
    }

    loadExperianData(experian) {
        this.setState({ experianData: { experianResponse : { loading: true } } })
        return api.queryExperianId(experian, this.state.companyId).then((response) => {

            const processedDoc = response.body.processedDoc;
            const htmlDoc = response.body.htmlDoc;

            let el = document.createElement( 'html' );
            el.innerHTML = `<html>${response.text}</html>`;

            const body      = htmlDoc;
            const title     = processedDoc.title;
            const company   = processedDoc.company;
            const address   = processedDoc.address;

            let experianRatings = {
                delinquency: {
                    risk: null,
                    trend: null
                },
                financial: {
                    risk: null,
                    trend: null
                },
                bankruptcy: null
            };

            experianRatings.delinquency = processedDoc.delinquencyRating;

            experianRatings.financial = processedDoc.financialRating;

            experianRatings.bankruptcy = !!processedDoc.bankruptcyRating;

            this.setState({
                experianData: {
                    experianResponse: { title, body, company, address, success: true },
                    experianRatings: experianRatings
                }
            })
        }).catch((error) => {
            this.setState({
                experianData: {
                    experianResponse: {
                        title: "Request failed",
                        body: "Could not fetch experian data",
                        address: null,
                        success: false
                    }
                }
            })
        });
    }

    goBack() {
        this.props.router.push("/start");
    }

    updateFilters(filters) {
        const newFilters = {
            ...this.state.filters,
            ...filters
        };
        this.setState({ filters: newFilters });
        this.props.updateFilters(
            this.props.params.companyId,
            newFilters
        );
    }

    handlePodsVisibility(section, collapsed) {
        const prefs = {
            ...this.state.prefs,
            [PERSISTED_FILTERS_MAP[section]]: collapsed
        }
        this.setState({ prefs });
        this.props.updatePrefs(this.props.params.companyId, prefs);
    }

    buildSanctionsPod() {
        if (this.state.companyData && this.state.companyData.companyTitle) {
            let auth = storage.getObject("lnei");
            if (auth && auth.authInfo && auth.authInfo.type === "WAM") {
                // redirect to WAM
                window.location = auth.serverInfo.wamLogin + "?back=" + encodeURIComponent(auth.serverInfo.customerUi) + "&aci=" + auth.serverInfo.wamAciCode;
            } else {
                return (<EntityDashboardSanctionsPod companyId={this.state.companyId}
                                                     entityName={this.state.companyData.companyTitle}
                                                     backRoute={`/entity-dashboard/${this.state.companyId}`}/>)
            }

        } else {
            return null;
        }
    }

    render() {

        let newsVolumeChartTitle = '',
            companyTitle         = '';

        if (this.state.companyData && this.state.companyData.companyTitle) {
            newsVolumeChartTitle = this.state.companyData.companyTitle +
                ': ' + this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.chartPod.newsVolume'});

            companyTitle = this.state.companyData.companyTitle;
        }

        let persistedFiltersVisibility = {};
        forEach(PERSISTED_FILTERS_MAP, (value, key) => {
            persistedFiltersVisibility[key] = this.props.prefs[value];
        });

        return (
            <div className="entity-dashboard">

                <span className="back-to-previous-page" onClick={this.goBack}>
                    <span className="la-TriangleLeft"></span>
                    <span className="text">
                        <FormattedMessage id="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                    </span>
                </span>

                <AboutThisEntity companyId={this.state.companyId}
                                 companyData={this.state.companyData}
                                 experianData={this.state.experianData}
                                 categories={this.state.categories}/>
                <div className={"dashboard-page"}>
                    <div className="dashboard-page__columns">
                        <EntityDashboardFilters changeHandler={this.updateFilters}
                                                filtersState={this.getFilters()}
                                                filtersCollapsed={persistedFiltersVisibility}
                                                onToggleVisibility={this.handlePodsVisibility}/>

                        <div className="dashboard-page__results">
                            {this.state.companyData && this.state.companyData.companyTitle && (
                                <EntityDashboardSanctionsPod companyId={this.state.companyId}
                                                             entityName={this.state.companyData.companyTitle}
                                                             backRoute={`/entity-dashboard/${this.state.companyId}`}/>
                            )}

                            <NewsVolumeChart
                                {...this.getFilters()}
                                companyId={this.state.companyId}
                                entities={{
                                    type: ENTITIES_FILTER_SPECIFIC,
                                    entitiesId: [this.state.companyId],
                                    categories: {
                                        allCategories: true,
                                        allUnassigned: true,
                                        categoriesId: []
                                    }
                                }}
                                companyTitle={companyTitle}
                                podTitle={newsVolumeChartTitle}
                                backRoute={`/entity-dashboard/${this.state.companyId}`}/>

                            <TrendingTerms
                                {...this.getFilters()}
                                entities={{
                                    type: ENTITIES_FILTER_SPECIFIC,
                                    entitiesId: [this.state.companyId],
                                    categories: {
                                        allCategories: true,
                                        allUnassigned: true,
                                        categoriesId: []
                                    }
                                }}
                                companyTitle={companyTitle}
                                riskEntityId={this.state.companyId}
                                backRoute={`/entity-dashboard/${this.state.companyId}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// PERSISTENCE -- Getters

const getEntityFilters = (companyId, defaultFilters) => {
    if (window.localStorage[LS_KEY_PERSISTED_ENTITY_FILTERS(companyId)]) {
        return JSON.parse(window.localStorage[LS_KEY_PERSISTED_ENTITY_FILTERS(companyId)]);
    } else {
        return defaultFilters
    }
}

const getEntityPrefs = (companyId, defaultPrefs) => {
    if (window.localStorage[LS_KEY_PERSISTED_ENTITY_PREFS(companyId)]) {
        return JSON.parse(window.localStorage[LS_KEY_PERSISTED_ENTITY_PREFS(companyId)]);
    } else {
        return defaultPrefs
    }
}

// PERSISTENCE -- Setters

const updateEntityFilters = (companyId, filters) => {
    window.localStorage.setItem(LS_KEY_PERSISTED_ENTITY_FILTERS(companyId), JSON.stringify(filters));
}

const updateEntityPrefs = (companyId, prefs) => {
    window.localStorage.setItem(LS_KEY_PERSISTED_ENTITY_PREFS(companyId), JSON.stringify(prefs));
}

// PERSISTENCE -- Mapping

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        filters: getEntityFilters(ownProps.params.companyId, utils.filterConvertFromPref(state.user.preferences.filters)),
        prefs: getEntityPrefs(ownProps.params.companyId, state.user.preferences.dashboard)
    }
}

const mapDispatchToProps = () => {
    return {
        updateFilters: updateEntityFilters,
        updatePrefs: updateEntityPrefs,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(EntityDashboard)));



// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/EntityDashboard.jsx